import { asciiValidator as asciiValidatorFromPackage } from '@patrianna/shared-utils/hookFormValidators/asciiValidator'
import { nameValidator as nameValidatorFromPackage } from '@patrianna/shared-utils/hookFormValidators/nameValidator'
import { requiredValidator as requiredValidatorFromPackage } from '@patrianna/shared-utils/hookFormValidators/requiredValidator'

import { getMaxContribute } from './jackpot'

export const REGEX_NAME = /^[a-zA-Z'`\- ]+$/
const REGEX_EMAIL_WITHOUT_SPEC_SYMBOL = /^[._%+-]+[A-Z0-9]|([._%+-])\1|[A-Z0-9]+[._%+-]+@/i
const REGEX_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9]+[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export const nameValidator = (errorOnInvalidName: string) => {
  return {
    ...nameValidatorFromPackage(),
    validate: {
      ...nameValidatorFromPackage().validate,
      regexp: (value: string) => REGEX_NAME.test(value) || errorOnInvalidName,
    },
  }
}

export const cardHolderNameValidator = (invalidNameMessage: string, requiredMessage?: string) => ({
  ...nameValidator(invalidNameMessage),
  ...requiredValidatorFromPackage(requiredMessage),
})

export const phoneNumberValidator = (errorOnInvalidPhone: string, errorNoPhone: string) => {
  return {
    ...requiredValidatorFromPackage(errorNoPhone),
    validate: (value: string) => /^\d{10}$/i.test(value) || errorOnInvalidPhone,
  }
}

export const contributionAmountValidator = (amount: number) => {
  const minAmount = 50
  const maxAmount = getMaxContribute(amount)

  return {
    validate: {
      minContributionValue: (value: string) => {
        const contribute = Number(value)
        if (contribute < minAmount) {
          return `Contribution needs to be at least ${minAmount}`
        }
      },
      maxContributionValue: (value: string) => {
        const contribute = Number(value)
        if (contribute > maxAmount) {
          return `Contribution needs to be no more ${maxAmount}`
        }
      },
    },
  }
}

export const emailValidatorHookForm = (invalidEmailMessage: string, requiredValidationMessage?: string) => {
  return {
    ...requiredValidatorFromPackage(requiredValidationMessage),
    validate: {
      ascii: asciiValidatorFromPackage,
      validEmail: (value: string) => {
        if (REGEX_EMAIL_WITHOUT_SPEC_SYMBOL.test(value) || !REGEX_EMAIL.test(value)) {
          return invalidEmailMessage
        }

        return true
      },
    },
  }
}
